import React from 'react';

const ErrorIcon = ({ width = 20, height = 20, color = '#CC0029', className = '' }) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill={color} />
      <path d="M10 11.3749L13.6876 15.0625L15.0625 13.6875L11.3749 9.99999L15.0625 6.31244L13.6876 4.9375L10 8.62505L6.31244 4.9375L4.9375 6.31244L8.62506 9.99999L4.9375 13.6875L6.31244 15.0625L10 11.3749Z" fill="white" />
    </svg>
  );
};

export default ErrorIcon;
